import { z } from 'zod';
export const supportSourceEnum = z.enum(['BOT', 'WEBAPP']);
export const supportStatusEnum = z.enum(['NEW', 'IN_PROGRESS', 'RESOLVED']);
export const createSupportRequestSchema = z.object({
    message: z.string().min(5).max(2000),
    contact: z.string().max(255).optional(),
    source: supportSourceEnum.default('WEBAPP'),
});
export const supportRequestSchema = z.object({
    id: z.string(),
    userId: z.string(),
    message: z.string(),
    contact: z.string().nullable(),
    source: supportSourceEnum,
    status: supportStatusEnum,
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const supportRequestListSchema = z.array(supportRequestSchema);
//# sourceMappingURL=support.js.map